import React, { Component } from 'react';
import NumericLabel from 'react-pretty-numbers';
import { showCurrencyFormat } from '../../../utils';
export default class FieldInput extends Component{
  constructor(props){
    super(props);
    this.state = {
      fieldFocus : false,
    }
  }
  handleFocus = () => {
    this.setState({
      fieldFocus: true,
    });
  }
  handleBlur = (e) => {
    this.setState({
      fieldFocus: false,
    });
    this.props.updateField(this.props.keyParam, e.target.value != '' ? e.target.value : null);
    if(this.props.handleOnBlur){
      this.props.handleOnBlur(this.props.keyParam, e.target.value != '' ? e.target.value : null)
    }
  }
  render(){
    const { type, value, keyParam, currency, currencyType, percentage,disable, maxLength } = this.props;
    if(type != 'view'){
      return (
        <input type="text"
          value={ (value != '' || value != null || value != undefined) ? value : currency ? 0:''}
          onChange={(e) => this.props.updateField(keyParam, e.target.value)}
          onFocus={() => this.handleFocus()}
          onBlur={(e) => this.handleBlur(e)}
          disabled={disable? disable :false}
          style={this.props.style}
          maxLength={maxLength}
        />
      )
    }else{
      if(currency){
        return (<h6 style={{wordWrap:'break-word'}}>{value ? <NumericLabel params={showCurrencyFormat(currencyType)}>{value}</NumericLabel>:'0'} </h6>)
      }else{
        return (<h6>{value ?  value : '--'} { value && percentage ? '%' : null} </h6>)
      }
    }
  }
}
